import dayjs from "dayjs";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import { loadSingleStaff } from "../../redux/rtk/features/user/userSlice";
import { deleteWorkPlaceHistory } from "../workPlaceHistory/workPlaceHistoryApis";
import BtnDeleteSvg from "./Button/btnDeleteSvg";
import WorkPlaceEditSinglePopup from "./PopUp/WorkPlaceEditSinglePopup";
import WorkPlaceTimelineSvg from "./WorkPlaceTimelineSvg";

const EmployeeWorkPlace = ({ list, edit, setLoading }) => {
	const user_id = useParams("id");
	const dispatch = useDispatch();

	const deletedWorkPlaceHistory = async (id) => {
		setLoading(true);
		const { data } = await deleteWorkPlaceHistory(id);

		// check if data is deleted or not and call the setPopUp function
		if (data) {
			dispatch(loadSingleStaff(user_id.id));
			setLoading(false);
		} else {
			setLoading(false);
		}
	};
	return (
		<div>
			<main class="container mx-auto w-full flex justify-center mt-5">
				<ol class="border-l-2 border-slate-600">
					{list &&
						list?.map((item) => {
							const startDate = item?.startDate
								? dayjs(item?.startDate).format("DD/MM/YYYY")
								: "Not Available";
							const endDate = item?.endDate
								? dayjs(item?.endDate).format("DD/MM/YYYY")
								: "Present";

							const startYear = item?.startDate
								? dayjs(item?.startDate).format("YYYY")
								: "Not Available";
							const endYear = item?.endDate
								? dayjs(item?.endDate).format("YYYY")
								: "Present";

							return (
								<li key={item.id}>
									<div class="md:flex flex-start">
										<WorkPlaceTimelineSvg />
										<div class="block p-6  max-w-md ml-6 mb-5 ">
											<div class="flex justify-between mb-4">
												<Heading>{item?.workplace?.workplace}</Heading>

												<Heading>
													{startYear} - {endYear}
												</Heading>

												{edit && (
													<div>
														<WorkPlaceEditSinglePopup
															data={item}
															setLoading={setLoading}
														/>

														<button
															onClick={() =>
																deletedWorkPlaceHistory(item.id)
															}>
															<BtnDeleteSvg size={20} 
															/>
														</button>
													</div>
												)}
											</div>

											<Heading1>
												Comment : <Heading2>{item?.comment || "None"}</Heading2>
											</Heading1>
											<Heading1 class="">
												Start Date : <Heading2>{startDate}</Heading2>
											</Heading1>

											<Heading1 class="">
												End Date : <Heading2>{endDate}</Heading2>
											</Heading1>
										</div>
									</div>
								</li>
							);
						})}
				</ol>
			</main>
		</div>
	);
};

const Heading = tw.h3`
font-medium
text-base
mr-20
w-500
txt-color-2
		 `;

const Heading1 = tw.h3`
font-medium
text-sm
mr-20
w-500
txt-color-2
		 `;

const Heading2 = tw.span`
font-medium 
text-sm
txt-color-secondary`;

export default EmployeeWorkPlace;
